import { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { getUserList } from 'api/userApi';
import { USER_UPDATE } from 'containers/pages/ManageUsers/duck/types';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

// This custom hook returns any functionality needed to use and update the root user list
// Destructuring state / dispatch from this custom hook can be used in place of the useContext hook
interface UsersState {
  userUpdate: boolean;
}

interface RootState {
  users: UsersState;
}
export const useRootUserList = () => {
  const { userUpdate } = useSelector((state: RootState) => state?.users);
  const dispatch = useDispatch();
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  const {
    isLoading: rootUserListLoading,
    data,
    isError: rootUserListError,
    refetch: updateRootUserList,
  } = useQuery('getUserList', () => getUserList(authV3Enabled));

  const rootState = {
    rootUserListLoading,
    rootUserList: data?.result ?? [],
    rootUserListError,
  };

  useEffect(() => {
    if (userUpdate && !rootUserListLoading) {
      dispatch({ type: USER_UPDATE, payload: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userUpdate, rootUserListLoading]);

  return { rootState, updateRootUserList };
};
